import { field, label } from '../contacts/Sheet.tsx';
import { DEPARTMENT_CHOICES, type DepartmentChoice } from '../../tasks/departmentFilter.ts';

/** The department filter, drawn as the Timeline's is (TimelineSection.tsx): All, then the five task departments. */
export function DepartmentSelect({ value, onChange }: { value: DepartmentChoice; onChange: (d: DepartmentChoice) => void }) {
  return (
    <label className={label}>Department
      <select value={value} onChange={(e) => onChange(e.target.value as DepartmentChoice)} className={field}>
        <option value="">All</option>
        {DEPARTMENT_CHOICES.map((d) => <option key={d} value={d}>{d}</option>)}
      </select>
    </label>
  );
}
